import React from 'react';

export interface Props {
  children: React.ReactNode;
}

export const MobileActionContainer: React.FC<Props> = (props) => {
  let { children } = props;

  return (
    <div>
      <div className="hidden md:block">{children}</div>
      <div className="fixed bottom-0 left-0 w-full md:hidden bg-white px-4 py-6">{children}</div>
    </div>
  );
};
